import { render } from "./datetime-local.vue?vue&type=template&id=620a5dfa&ts=true"
import script from "./datetime-local.vue?vue&type=script&lang=ts"
export * from "./datetime-local.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__